export const PATH_NAME = {
	ROOT: '/',
	PLAYGROUND: '/playground',
	ERROR_404: '/404',
	ERROR_403: '/403',
	LOGIN: '/login',
	SIGNUP: '/signup',
	DASHBOARD: '/dashboard',
	HOME: '/home',
	VERIFICATION_LINK: '/verification/link',
	FORGET_PASSWORD: '/password/forget',
	ACTIONABLE_INSIGHTS: '/actionable/insights',
	REPORTING_INSIGHTS: '/reporting/insights',
	MOOD_INSIGHTS: '/mood/insights',
	CAMPAIGN_INSIGHTS: '/campaign/insights',
	CAMPAIGN_ALERT: '/campaign/alert',
	REPORTING_SENTIMENTS: '/reporting/sentiments',
	ISSUES_RAISED: '/issues/raised',
	EMPLOYEES_LIST: '/employees/list',
	EMPLOYEE_ADD: '/employee/add',
	EMPLOYEE_EDIT: '/employee/edit',
	EMPLOYEE_DETAILS: '/employee/:employeeId',
	CRITICAL_RISK: '/risks',
	CAMPAIGN_LIST: '/campaign/list',
	CAMPAIGN_DETAILS: '/campaign/:id',
	CAMPAIGN_CREATE: '/campaign/create',
	CAMPAIGN_EDIT: '/campaign/edit',
	CAMPAIGN_COPY: '/campaign/copy',
	LEADING_TURNOVER: '/leading/turnover',
	INTEGRATION: '/integration',
	FEEDBACK_CALL: '/feedback/call',
	CONVERSATIONS: '/conversations',
	SETTINGS: '/settings',
	SUPPORT: '/support',
	SUBSCRIPTION: '/subscription',
	CAMPAIGN_SCHEDULING: '/campaign-scheduling',
	PUBLIC_INBOUND: '/inbound-call/:id',    // public path
    PUBLIC_INBOUND_CALL: '/inbound-call/:id/call', // public path for users
	INBOUND_CALL_LIST: '/inbound-call-list', // private path for admin
	AGENTS_LIST: '/agents', // path for agents list
	COMING_SOON: '/coming-soon',
};
